import { gql } from '@apollo/client';

export const FETCH_HOSTING_LOCATIONS = gql`
  query FindAllHostingLocations {
    findAllHostingLocations {
      ITApllicationsEntity {
        HostingLocationsAsset {
          address
          businessOwnerEmail
          businessOwnerName
          drInPlace
          tier {
            id
            name
            color
          }
          hostingAssetOrServer
          hostingEntityName
          itOwnerEmail
          itOwnerName
          rebuildTime
          type
          uuid
        }
        HostingLocationsEntity {
          address
          businessOwnerEmail
          businessOwnerName
          drInPlace
          tier {
            id
            name
            color
          }
          hostingAssetOrServer
          hostingEntityName
          itOwnerEmail
          itOwnerName
          rebuildTime
          type
          uuid
        }
        application
        applicationType
        description
        drpDate
        drpLink
        lastDrpTest
        mto
        rpo
        rto
        sla
        supportsEmployees
        supportsLifeSafety
        supportsOther
        supportsRegulation
        supportsReputation
        supportsRevenue
        uuid
      }
      ITApplicationsAsset {
        application
        applicationType
        description
        drpDate
        drpLink
        lastDrpTest
        mto
        rpo
        rto
        sla
        supportsEmployees
        supportsLifeSafety
        supportsOther
        supportsRegulation
        supportsReputation
        supportsRevenue
        uuid
      }
      address
      businessOwnerEmail
      businessOwnerName
      drInPlace
      tier {
        id
        name
        color
      }
      hostingAssetOrServer
      hostingEntityName
      itOwnerEmail
      itOwnerName
      rebuildTime
      type
      uuid
    }
  }
`;

export const CREATE_HOSTING_LOCATION = gql`
  mutation CreateHostingLocation($data: CreateHostingLocationInput!) {
    createHostingLocation(data: $data) {
      ITApllicationsEntity {
        HostingLocationsAsset {
          address
          businessOwnerEmail
          businessOwnerName
          drInPlace
          tier {
            id
            name
            color
          }
          hostingAssetOrServer
          hostingEntityName
          itOwnerEmail
          itOwnerName
          rebuildTime
          type
          uuid
        }
        HostingLocationsEntity {
          address
          businessOwnerEmail
          businessOwnerName
          drInPlace
          tier {
            id
            name
            color
          }
          hostingAssetOrServer
          hostingEntityName
          itOwnerEmail
          itOwnerName
          rebuildTime
          type
          uuid
        }
        application
        applicationType
        description
        drpDate
        drpLink
        lastDrpTest
        mto
        rpo
        rto
        sla
        supportsEmployees
        supportsLifeSafety
        supportsOther
        supportsRegulation
        supportsReputation
        supportsRevenue
        uuid
      }
      ITApplicationsAsset {
        application
        applicationType
        description
        drpDate
        drpLink
        lastDrpTest
        mto
        rpo
        rto
        sla
        supportsEmployees
        supportsLifeSafety
        supportsOther
        supportsRegulation
        supportsReputation
        supportsRevenue
        uuid
      }
      address
      businessOwnerEmail
      businessOwnerName
      drInPlace
      tier {
        id
        name
        color
      }
      hostingAssetOrServer
      hostingEntityName
      itOwnerEmail
      itOwnerName
      rebuildTime
      type
      uuid
    }
  }
`;

export const UPDATE_HOSTING_LOCATION = gql`
  mutation UpdateHostingLocation($data: UpdateHostingLocationInput!) {
    updateHostingLocation(data: $data) {
      ITApllicationsEntity {
        HostingLocationsAsset {
          address
          businessOwnerEmail
          businessOwnerName
          drInPlace
          tier {
            id
            name
            color
          }
          hostingAssetOrServer
          hostingEntityName
          itOwnerEmail
          itOwnerName
          rebuildTime
          type
          uuid
        }
        HostingLocationsEntity {
          address
          businessOwnerEmail
          businessOwnerName
          drInPlace
          tier {
            id
            name
            color
          }
          hostingAssetOrServer
          hostingEntityName
          itOwnerEmail
          itOwnerName
          rebuildTime
          type
          uuid
        }
        application
        applicationType
        description
        drpDate
        drpLink
        lastDrpTest
        mto
        rpo
        rto
        sla
        supportsEmployees
        supportsLifeSafety
        supportsOther
        supportsRegulation
        supportsReputation
        supportsRevenue
        uuid
      }
      ITApplicationsAsset {
        application
        applicationType
        description
        drpDate
        drpLink
        lastDrpTest
        mto
        rpo
        rto
        sla
        supportsEmployees
        supportsLifeSafety
        supportsOther
        supportsRegulation
        supportsReputation
        supportsRevenue
        uuid
      }
      address
      businessOwnerEmail
      businessOwnerName
      drInPlace
      tier {
        id
        name
        color
      }
      hostingAssetOrServer
      hostingEntityName
      itOwnerEmail
      itOwnerName
      rebuildTime
      type
      uuid
    }
  }
`;

export const DELETE_HOSTING_LOCATION = gql`
  mutation DeleteHostingLocation($uuid: ID!) {
    deleteHostingLocation(uuid: $uuid) {
      ITApllicationsEntity {
        HostingLocationsAsset {
          address
          businessOwnerEmail
          businessOwnerName
          drInPlace
          tier {
            id
            name
            color
          }
          hostingAssetOrServer
          hostingEntityName
          itOwnerEmail
          itOwnerName
          rebuildTime
          type
          uuid
        }
        HostingLocationsEntity {
          address
          businessOwnerEmail
          businessOwnerName
          drInPlace
          tier {
            id
            name
            color
          }
          hostingAssetOrServer
          hostingEntityName
          itOwnerEmail
          itOwnerName
          rebuildTime
          type
          uuid
        }
        application
        applicationType
        description
        drpDate
        drpLink
        lastDrpTest
        mto
        rpo
        rto
        sla
        supportsEmployees
        supportsLifeSafety
        supportsOther
        supportsRegulation
        supportsReputation
        supportsRevenue
        uuid
      }
      ITApplicationsAsset {
        application
        applicationType
        description
        drpDate
        drpLink
        lastDrpTest
        mto
        rpo
        rto
        sla
        supportsEmployees
        supportsLifeSafety
        supportsOther
        supportsRegulation
        supportsReputation
        supportsRevenue
        uuid
      }
      address
      businessOwnerEmail
      businessOwnerName
      drInPlace
      tier {
        id
        name
        color
      }
      hostingAssetOrServer
      hostingEntityName
      itOwnerEmail
      itOwnerName
      rebuildTime
      type
      uuid
    }
  }
`;

export const GET_HOSTING_LOCATIONS_IT_APPLICATIONS = gql`
  query FindAllHostingLocations {
    findAllHostingLocations {
      uuid
      hostingAssetOrServer
      hostingEntityName
    }
  }
`;
